module.exports = "/_next/static/images/83c688b3738897ea472250868f9d857e-roxinho-details-metalico-md@3x.jpg.webp";